export async function customFetch(url, options = {}, creditals = true) {
  let defaultOptions = {}
  
  if (creditals) {
    defaultOptions = {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    };
  } else {
    defaultOptions = {
      headers: {
        "Content-Type": "application/json"
      },
    };
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };
  const res = await fetch(url, mergedOptions);
  return res;
}